import { Icon } from '@hologram-dimension/icon';
import { FC, useState } from 'react';
import clsx from 'clsx';
import styles from './ClickToCopy.module.css';

const ClickToCopy: FC<{ value: string; label: React.ReactNode; className?: string }> = ({
  value,
  label,
  className,
}) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };
  return (
    <button
      type="button"
      className={clsx(styles.clickToCopy, className)}
      onClick={() => {
        copyToClipboard(value);
      }}
    >
      {label}
      {copied ? (
        <Icon
          name="CircleCheckmark"
          size="medium"
          fill="DdsColorIconSuccess"
          className={styles.copySuccess}
        />
      ) : (
        <Icon className={styles.copyIcon} name="Copy" size="medium" fill="currentColor" />
      )}
    </button>
  );
};

export default ClickToCopy;
